import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2aeff7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " E-Mail Customization ")
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "list mt-2" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help_tooltip = _resolveComponent("help-tooltip")!
  const _component_EmailCustomization = _resolveComponent("EmailCustomization")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_ctx.selectedEmailTypeName = 'Welcome E-Mail'; _ctx.selectedEmailType = 'welcome'}, ["stop"]))
            }, [
              _createElementVNode("h2", _hoisted_6, [
                _createTextVNode("Welcome E-Mail "),
                _createVNode(_component_help_tooltip, { text: "When a process is created, this e-mail is sent to all users of the external client." })
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.welcomeTemplates, (tpl) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mt-2 pt-1 pb-2 cursor-pointer",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#emailCustomization",
                    key: tpl.typeId,
                    onClick: ($event: any) => {_ctx.selectedItemId = tpl.typeId; _ctx.selectedProcessName = tpl.name}
                  }, [
                    _createElementVNode("u", null, _toDisplayString(tpl.name), 1)
                  ], 8, _hoisted_8))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_EmailCustomization, {
      typeId: _ctx.selectedItemId,
      emailType: _ctx.selectedEmailType,
      emailTypeName: _ctx.selectedEmailTypeName,
      processName: _ctx.selectedProcessName
    }, null, 8, ["typeId", "emailType", "emailTypeName", "processName"])
  ]))
}